import { FetchGet } from "../components/Utils";
import { IPlayer } from "../types";

interface FetchMeResponse {
  player: IPlayer | null;
  error?: unknown;
}

export const fetchMe = async (
  data: Record<string, string>,
  headers: Record<string, string> | {},
): Promise<FetchMeResponse> => {
  try {
    const res = await FetchGet("me/", data, headers);
    return await res.json();
  } catch (err) {
    console.error(err);
    return { player: null, error: err };
  }
};
